import "./bootstrap.min.css";
import "./font-awesome/css/all.css";
import "./style2021.css";
import "./979px-1340px.css";
import "./max-979px2020.css";
import "./angularjs-datetime-picker.css";
import "./angular-date-picker.css";
import "./compliance2020.css";
import "./supportScreen2020.css";
import "./blocworx-customer-targeted.css";
import "./moment-calendar.css";
import "./blocworx-customer.css";
import "./Glyphter.css";
import "./components.css";

//This code snippet dynamically loads a CSS file if it exists, using the Fetch API to check for its availability before appending it to the document head.
async function loadCSSIfExists(filePath: string): Promise<void> {
    try {
        const response = await fetch(filePath, { method: 'HEAD' });
        if (response.ok) {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = filePath;
            document.head.appendChild(link);
            console.log(`${filePath} loaded successfully`);
        } else {
            console.warn(`${filePath} not found`);
        }
    } catch (error) {
        console.error(`Error loading CSS file: ${filePath}`, error);
    }
}

(async () => {
    await loadCSSIfExists("./custom-css.css");
})();
